import { takeEvery, fork, put, all, call } from "redux-saga/effects";
import {
  GET_USER,
  USER_CHANGE_PASSWORD,
  // ADD_MENU,
  // PUT_MENU,
  // DELETE_MENU,
  // API_ERROR,
} from "./actionTypes";

import {
  apiError,
  // get_menu, add_menu,
  getUserSuccessful,
} from "./actions";
import {
  getList,
  // postAdd,
  postEdit,
  //  postDelete
} from "../../helpers/Helper";
import swal from "sweetalert";

//If user is login then dispatch redux action's are directly from here.
function* getUserlist({ payload }) {
  try {
    const response = yield call(getList, "/users/iamuser/" + payload.user, {});
    yield put(
      getUserSuccessful({
        response: {
          ...response,
          location_id: response.location ? response.location.id : 0,
          locationLabel: response.location ? response.location.name : 0,
          departments: response.departments.map((item, index) => ({
            label: item.name,
            value: item.id,
          })),
        },
      })
    );

    // history.push("/dashboard");
  } catch (error) {
    yield put(apiError(error));
  }
}
function* UserChangePassword({ payload: { data, history } }) {
  try {
    const response = yield call(postEdit, "/users/changepassword/", data);
    if (response.status === 200) {
      swal("Your Password Change Successfully.!", {
        icon: "success",
        timer: 1500,
      });
      history.push("/dashboard");
    } else {
      swal("Sorry! Unable to Change Password. Please Try Again!", {
        icon: "error",
      });
    }
  } catch (error) {
    yield put(apiError(error));
  }
}

// function* addMenu({ payload: { history } }) {
//   try {
//     localStorage.removeItem("authUser");

//     history.push("/login");
//   } catch (error) {
//     yield put(apiError(error));
//   }
// }

export function* watchUserList() {
  yield takeEvery(GET_USER, getUserlist);
}
export function* watchUserChangePassword() {
  yield takeEvery(USER_CHANGE_PASSWORD, UserChangePassword);
}

// export function* watchAddMenu() {
//   yield takeEvery(ADD_MENU, addMenu);
// }

function* userProfileSaga() {
  yield all([fork(watchUserList), fork(watchUserChangePassword)]);
}

export default userProfileSaga;
